import { render } from "./TasksCompletedList.vue?vue&type=template&id=2a9ef5de&scoped=true"
import script from "./TasksCompletedList.vue?vue&type=script&lang=js"
export * from "./TasksCompletedList.vue?vue&type=script&lang=js"

import "./TasksCompletedList.vue?vue&type=style&index=0&id=2a9ef5de&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a9ef5de"]])

export default __exports__